import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';

import { fetchUserInfo } from '../store/slices/userSlice';
import { useAppDispatch } from '../store/store';
import Preloader from './Preloader/Preloader';

// auth_token теперь httpOnly (сервер ставит его через Set-Cookie) -
// Cookies.get('auth_token') больше НИЧЕГО не вернёт, это не ошибка, а
// техническое ограничение браузера. Проверяем авторизацию реальным
// запросом к серверу: если кука валидна, браузер приложит её сам
// (см. withCredentials в api.js), userinfo ответит успехом.
function ProtectedRoute({ children }) {
  const dispatch = useAppDispatch();

  // Раньше здесь читался общий state.user.fetchStatus - тот же флаг,
  // который также трогает Header.jsx своим собственным fetchUserInfo()
  // при монтировании. Это создавало бесконечный цикл:
  //   Header монтируется -> сам вызывает fetchUserInfo -> fetchStatus
  //   на время запроса становится 'loading' -> ProtectedRoute (следящий
  //   за ТЕМ ЖЕ полем) реагирует на это как на "нужно перепроверить
  //   авторизацию" -> прячет children, то есть размонтирует Header ->
  //   запрос завершается -> children показываются снова -> Header
  //   монтируется заново -> цикл повторяется бесконечно.
  // Теперь ProtectedRoute следит только за результатом СВОЕГО
  // собственного запроса (через .unwrap(), локальный useState) и больше
  // не подписан на общее поле стора, которое может менять кто угодно.
  const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'denied'

  useEffect(() => {
    let cancelled = false;
    dispatch(fetchUserInfo())
      .unwrap()
      .then(() => {
        if (!cancelled) setStatus('ok');
      })
      .catch(() => {
        if (!cancelled) setStatus('denied');
      });
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  if (status === 'loading') {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Preloader />
      </div>
    );
  }

  if (status === 'denied') {
    // Разделяем два разных случая, а не просто "запрос не удался":
    // - реальный обрыв сети - этим уже занимается перехватчик в api.js
    //   (он сам переходит на "/" и показывает баннер офлайна, см.
    //   userSlice.js/Homepage.jsx). Если ещё и здесь уйти на /login,
    //   получится гонка двух навигаций от одного и того же события.
    // - сервер действительно ответил "не авторизован" - только тогда
    //   отправляем на /login.
    if (!navigator.onLine) {
      return children;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
